import { useNavigate, useSearch } from '@tanstack/react-router';

import { BasicFilterContainer } from '../../../cdl/Filter/BasicFilterContainer/BasicFilterContainer';
import { FilterMultiSelectFull } from '../../../cdl/Filter/FilterMultiSelectFull/FilterMultiSelectFull';
import { isEmptyFilterValue } from '../../../cdl/Filter/helper/isEmptyFilterValue';
import { normalizeFilterValue } from '../../../cdl/Filter/helper/normalizeFilterValue';
import { translate } from '../../../common/helpers/translate.helper';
import { useEnums } from '../../../common/hooks/useEnums';

const FILTER_KEYS = ['supplierProductGroups'] as const;

export const ProductsFilterPills = () => {
    const search = useSearch({ from: '/_app/products' });
    const navigate = useNavigate({ from: '/products' });
    const { getEnumsForTypeAndContext, getHumanReadableValue } = useEnums();

    const hasActiveFilters = FILTER_KEYS.some((key) => !isEmptyFilterValue(search[key]));

    const supplierGroupOptions = Object.keys(getEnumsForTypeAndContext('supplierProductGroup') ?? {}).map((key) => ({
        value: key,
        label: getHumanReadableValue('supplierProductGroup', key),
    }));

    const clearFilters = () => {
        navigate({
            search: (previousSearch) => ({
                ...previousSearch,
                ...Object.fromEntries(FILTER_KEYS.map((key) => [key, undefined])),
                page: 0,
            }),
        });
    };

    return (
        <BasicFilterContainer hasActiveFilters={hasActiveFilters} onClear={clearFilters}>
            <FilterMultiSelectFull
                label={translate('productsOverview.filters.supplier')}
                filterByLabel={translate('productsOverview.filters.filterBySupplier')}
                filterPlaceholder={translate('productsOverview.filters.filterBySupplier')}
                options={supplierGroupOptions}
                values={search.supplierProductGroups}
                onChange={(values) => {
                    navigate({
                        search: (previousSearch) => ({
                            ...previousSearch,
                            supplierProductGroups: normalizeFilterValue(values) as string[] | undefined,
                            page: 0,
                        }),
                    });
                }}
            />
        </BasicFilterContainer>
    );
};
